define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app'
  /* eslint-enable */
], function riqListenerHideHeaderModule(app) {
  'use strict';

  app.registerComponent('riqListenerHideHeader', {
    require: {},
    bindings: {},
    controller: 'riqListenerHideHeaderController'
  });
  app.registerController('riqListenerHideHeaderController', [
    '$rootScope',
    '$state',
    function controller($rootScope, $state) {
      $rootScope.hideHeader = false;
      var NO_HEADER_STATES = [
        'book_player_en',
        'class_login_en',
        'comprehension_check_en'
      ];

      var NO_HEADER_ONBOARDING_STEP_PARAMS = [
        'marketingSurvey',
        'parentExpectations',
        'teacherOnboarding'
      ];

      var _checkHeaderState = function _checkHeaderState(
        stateName,
        stateParams
      ) {
        var isNoHeaderState = NO_HEADER_STATES.indexOf(stateName) > -1;
        var isOnboardingStepParams =
          stateName.indexOf('onboarding') > -1 &&
          NO_HEADER_ONBOARDING_STEP_PARAMS.indexOf(stateParams.step) > -1;
        const isTeacherDashboardProgressReport =
          stateParams.page && stateParams.page.includes('classroom-report');
        if (
          isNoHeaderState ||
          isOnboardingStepParams ||
          isTeacherDashboardProgressReport
        ) {
          $rootScope.hideHeader = true;
        } else {
          $rootScope.hideHeader = false;
        }
      };

      $rootScope.$watch('$state.params', function() {
        _checkHeaderState($state.current.name, $state.params);
      });

      $rootScope.$on('$onStateChangeSuccess', function onStateChangeSuccess(
        event,
        toState,
        toStateParams
      ) {
        _checkHeaderState(toState.name, toStateParams);
      });
    }
  ]);
});
